import React, { useEffect, useState } from "react";
import {
  Modal,
  Input,
  Button,
  Table,
  Upload,
  message,
  Select,
  Divider,
} from "antd";
 
import {
  DeleteOutlined,
  DownloadOutlined,
  EyeOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import {
  IPreAuthQueryReply,
  QueryData,
} from "../../../interfaces/IPreAuthQuery"; // Import the QueryData interface
import { IUploadReferral } from "../../../interfaces/IReferral";
import { UploadDocument } from "../../../models/EnhancementSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import {
  fetchQueries,
  replyResponseToQuery,
} from "../../../models/preAuthQuerySlice";
import { getDocuments } from "../../../apis/schemeService";
import "./PreAuthQueryCss.css";
import { errorMessage, successMessage } from "../../../utils/notificationUtils";
import { downloadDocument } from "../../../apis/patientService";
 
const { Dragger } = Upload;
 
interface Document {
  id: number;
  type?: string;
  file?: any;
  uploaded?: boolean;
  documentId?: string;
  isInitial?: boolean;
  documentName?: string;
  documentUrl?: string;
}
 
interface RequiredDocument {
  id: number;
  name: string;
  expiryDate: string;
  documentName: string;
  documentType: string;
  documentUrl: string;
  documentLabelType: string;
}
interface ReplyQueryModalProps {
  visible: boolean;
  onCancel: () => void;
  query: any; // This is the selected query passed from QueryTable
  portalMetaDataId: number;
  setIsModalReplyVisible: any;
}
 
const ViewResponseModal: React.FC<ReplyQueryModalProps> = ({
  visible,
  onCancel,
  query,
  portalMetaDataId,
  setIsModalReplyVisible,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  
  const getInitialDocuments = (requiredDocs: RequiredDocument[]) => {
    return requiredDocs && requiredDocs.length > 0
      ? requiredDocs?.map((doc, index) => ({
          id: index + 1,
          type: doc.documentLabelType,
          documentName: doc.documentName,
          file: undefined,
          documentId: doc.id.toString(),
          uploaded: false,
          isInitial: true,
          documentUrl: doc.documentUrl,
        }))
      : [{ id: 1, type: undefined, file: undefined }];
  };
 
  const [documents, setDocuments] = useState<Document[]>(
    getInitialDocuments(query?.returnedDocumentUrl || [])
  );
  const [isDownloadingDocument, setIsDownloadingDocument] = useState<boolean>(false);
  const [downloadingDocumentUrl, setDownloadingDocumentUrl] = useState<string>("");
 
 
  useEffect(() => {
    setDocuments(getInitialDocuments(query?.returnedDocumentUrl || []));
  }, [query]);
 
  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      setDownloadingDocumentUrl(url);
      setIsDownloadingDocument(true);
      await downloadDocument(fileName, url);
      successMessage("Document Downloaded Successfully");
      setDownloadingDocumentUrl("");
      setIsDownloadingDocument(false);
    } catch (err: any) {
      errorMessage("Please, Try again later");
      setDownloadingDocumentUrl("");
      setIsDownloadingDocument(false);
    }
  };
 
  return (
    <Modal
      //   title="Reply to Query"
      visible={visible}
      centered
      style={{ boxShadow: "0px 2px 8px 0px #00000040" }}
      onCancel={onCancel}
      footer={[
        <div style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
          <Button
            key="back"
            onClick={onCancel}
            style={{
              borderColor: "#008B8B",
              color: "#fff",
              boxShadow: "0px 2px 8px 0px #00000040",
              width: "25%",
              backgroundColor: "#008B8B",
            }}
          >
            Cancel
          </Button>
        </div>,
      ]}
      width={800}
    >
      <div style={{ marginBottom: "2rem" }} className="view-response">
        <p
          style={{
            marginBottom: "0.6rem",
            fontSize: "1rem",
            fontWeight: "700",
          }}
        >
          {"Query Response / Reply"}
        </p>
        <Input.TextArea
          value={query.returnedResponse}
          placeholder="Type your response here..."
          rows={5}
          disabled
        />
      </div>
      <p
        style={{ marginBottom: "0.7rem", fontSize: "1rem", fontWeight: "700" }}
      >
        Required Documents
      </p>
      {/* Documents table */}
      <div
        style={{
          borderRadius: "8px",
          border: "1px solid #D9D9D9",
          padding: "16px",
          marginBottom: "16px",
        }}
      >
        {/* <div style={{ marginBottom: "16px", fontWeight: "600" }}>
              DOCUMENTS :
            </div> */}
 
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            tableLayout: "fixed",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  padding: "8px",
                  borderTop: "1px solid #D9D9D9",
                  borderBottom: "1px solid #D9D9D9",
                  borderLeft: "1px solid #D9D9D9",
                  width: "30%", // Fixed width for the first column
                }}
              >
                Document Type
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "8px",
                  borderTop: "1px solid #D9D9D9",
                  borderBottom: "1px solid #D9D9D9",
                  width: "50%", // Fixed width for the second column
                }}
              >
                Selected File
              </th>
              <th
                style={{
                  textAlign: "center",
                  padding: "8px",
                  borderTop: "1px solid #D9D9D9",
                  borderBottom: "1px solid #D9D9D9",
                  borderRight: "1px solid #D9D9D9",
                  width: "20%", // Fixed width for the third column
                }}
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {documents?.map((doc, index) => (
              <tr key={doc.id}>
                <td
                  style={{
                    padding: "8px",
                    borderTop: "1px solid #D9D9D9",
                    borderBottom: "1px solid #D9D9D9",
                    borderLeft: "1px solid #D9D9D9",
                    overflow: "hidden", // Ensure no overflow
                    textOverflow: "ellipsis", // Ellipsis for overflow
                    whiteSpace: "nowrap", // Prevent wrapping
                  }}
                >
                  {doc.type}
                </td>
                <td
                  style={{
                    padding: "15px",
                    // borderTop: "1px solid #D9D9D9",
                    borderBottom: "1px solid #D9D9D9",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap", // Prevent text wrapping
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: "100%", // Ensure it respects column width
                    }}
                    title={doc.documentName}
                  >
                    {doc.documentName}
                  </span>
                </td>
                <td
                  style={{
                    padding: "8px",
                    borderTop: "1px solid #D9D9D9",
                    borderBottom: "1px solid #D9D9D9",
                    borderRight: "1px solid #D9D9D9",
                    textAlign: "center",
                    overflow: "hidden",
                  }}
                >
                  <Button
                    icon={<EyeOutlined />}
                    style={{
                      border: "none",
                      background: "none",
                      boxShadow: "none",
                    }}
                    onClick={() =>
                      window.open(doc.documentUrl ? doc.documentUrl : "")
                    }
                  />
                  <Button
                    icon={<DownloadOutlined />}
                    loading={isDownloadingDocument && doc?.documentUrl === downloadingDocumentUrl}
                    style={{
                        border: "none",
                        background: "none",
                        boxShadow: "none",
                      }}
                    onClick={() =>
                      handleDownloadDocument(
                        doc.documentName ? doc.documentName : "",
                        doc.documentUrl ? doc.documentUrl : ""
                      )
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Modal>
  );
};
 
export default ViewResponseModal;